import { store } from '@/firebase'
import {
  CollectionName,
  FSImportantNotice as LibFSImportantNotice
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  DocumentData,
  doc,
  orderBy,
  query,
  Timestamp,
  where
} from 'firebase/firestore'

export type { ImportantNoticeTheme } from '@WombatTechnology/nitte-time-lib'

export type FSImportantNotice = LibFSImportantNotice<Timestamp> & {
  title?: string | null
  eyeCatchImageUrl?: string | null
  urlButtonLabel?: string | null
}

export class ImportantNotice {
  static collection() {
    return collection(
      store,
      CollectionName.ImportantNotices
    ) as CollectionReference<FSImportantNotice>
  }

  static doc(id: string) {
    return doc<FSImportantNotice, DocumentData>(this.collection(), id)
  }

  /**
   * 公開済み（publishedAt <= now）のお知らせを新しい順に取得するクエリ。
   * 未来の publishedAt は表示対象外（予約投稿）。
   */
  static publishedQuery() {
    return query(
      this.collection(),
      where('publishedAt', '<=', Timestamp.now()),
      orderBy('publishedAt', 'desc')
    )
  }
}
